import React, { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import { getAccessToken } from '@functions/accessToken'

import useCurrentUser from '@hooks/useCurrentUser'
import useRoles from '@hooks/useRoles'
import useStatuses from '@hooks/useStatuses'

import AccessDenied from '@sections/Auth/AccessDenied'
import AdminRoutes from '@sections/Admin/routes'
import Login from '@sections/Auth/Login'

const adminRoles = ['Admin', 'Support']
const brandRoles = ['Brand Administrator']
const providerRoles = ['Provider Employee', 'Provider Director']

// When logging in the token is not instantly available
// We wait and check 0.1 second later for it to be available

type SetAccessToken = (token: string | null) => React.Dispatch<React.SetStateAction<string | null>>

const waitForAccessToken = (setAccessToken: SetAccessToken) => {
  const intervalId = setInterval(() => {
    const token = getAccessToken()
    if (token){
      clearInterval(intervalId)
      setAccessToken(token)
    }
  }, 100)
}

const AuthenticationController = () => {
  const [accessToken, setAccessToken] = useState(null)

  const auth0Payload = useAuth0()
  const { isAuthenticated, user } = auth0Payload

  useEffect(() => {
    waitForAccessToken(setAccessToken)
  }, [])

  const { 'https://www.realhubapp.com/role': userRole } = user || {}

  const performHttpRequests = accessToken && isAuthenticated

  useCurrentUser({ performHttpRequests })
  useRoles({ performHttpRequests })
  useStatuses({ performHttpRequests })

  if (!accessToken || !isAuthenticated){
    return <Login />
  }

  if (!adminRoles.includes(userRole) && !brandRoles.includes(userRole) && !providerRoles.includes(userRole)){
    return <AccessDenied />
  }

  return <AdminRoutes />
}

export default AuthenticationController
